/* eslint-disable no-shadow */
const state = {
	giftCard: {},
	giftCardAmount: {},
	giftCardNo: '',
	giftCardPin: '',
	coinRedeemValue: {},
	user: {},
	address: {},
	order: {},
	selectedAddressId: '',
	selectedAddress: {},
	userCart: '',
	orderId: 'ORD',
	loginStatus: false,
	status: '',
	promoCode: '',
	profile_picture: ''
}

const getters = {
	getUserData: state => state.user,
	getOrderIdData: state => state.orderId,
	getOrderData: state => state.order,
	getUserCartData: state => parseFloat(state.userCart),
	isAuthenticated: state => state.loginStatus,
	getAddress: state => state.address,
	getSelectedAddressId: state => state.selectedAddressId,
	getSelectedAddress: state => state.selectedAddress,
	getPromoCode: state => state.promoCode,
	getProfilePicture: state => state.profile_picture,
	getGiftCardDetails: state => state.giftCard,
	getGiftCardAmount: state => state.giftCardAmount,
	getGiftCardNo: state => state.giftCardNo,
	getGiftCardPin: state => state.giftCardPin,
	getCoinDetails: state => state.coinRedeemValue
}

const mutations = {
	setLoginStatusMutation: (state, payload) => {
		state.loginStatus = payload
	},
	setUserMutation: (state, payload) => {
		state.user = payload
		state.loginStatus = true
	},
	setOrderIdMutation: (state, payload) => {
		state.orderId = payload
	},
	setUserCartMutation: (state, payload) => {
		state.userCart = payload
	},
	setOrderMutation: (state, payload) => {
		state.order = payload
	},
	setSelectedAddressIdMutation: (state, payload) => {
		state.selectedAddressId = payload
	},
	setSelectedAddressMutation: (state, payload) => {
		if (state.selectedAddress && state.selectedAddress.length > 0) {
			state.selectedAddress = {}
		}
		state.selectedAddress = payload
		state.selectedAddressId = payload.addressId
	},
	setAddressMutation: (state, payload) => {
		state.address = payload
		if (payload && payload.length > 0) {
			state.selectedAddress = payload[0]
			state.selectedAddressId = payload[0].addressId
		}
	},
	setPromoCodeMutation: (state, payload) => {
		state.promoCode = payload
	},
	setProfilePictureMutation: (state, payload) => {
		state.profile_picture = payload
	},
	setGiftCardDataMutation: (state, payload) => {
		state.giftCard = payload
	},
	setGiftAmountDataMutation: (state, payload) => {
		state.giftCardAmount = payload
	},
	setGiftCardNoMutation: (state, payload) => {
		state.giftCardNo = payload
	},
	setGiftCardPinMutation: (state, payload) => {
		state.giftCardPin = payload
	},
	setCoinRedeemValueMutation: (state, payload) => {
		state.coinRedeemValue = payload
	},
	clearPromoCodeMutation: (state) => {
		state.promoCode = ''
	},
	deleteSelectedAddressMutation: (state, payload) => {
		state.selectedAddress = payload
		state.selectedAddressId = ''
	},
	clearUserMutation: (state) => {
		state.user = {}
		state.selectedAddressId = ''
		state.address = {}
		state.order = {}
		state.selectedAddress = {}
		state.userCart = ''
		state.loginStatus = false
	},
	clearAddressMutation: (state) => {
		state.address = {}
	},
	deleteAddressMutation: (state, payload) => {
		const index = state.address.findIndex(add => add.addressId === payload)
		state.address.splice(index, 1)
		if (state.address.length < 1) {
			state.selectedAddress = {}
			state.selectedAddressId = ''
		}
	},
	clearOrderMutation: (state) => {
		state.order = {}
	},
	clearProfilePictureMutation: (state) => {
		state.profile_picture = ''
	},
	clearGiftDataMutation: (state) => {
		state.giftCard = {}
	},
	clearGiftAmountDataMutation: (state) => {
		state.giftCardAmount = {}
	},
	clearGiftCardNoMutation: (state) => {
		state.giftCardNo = ''
	},
	clearGiftCardPinMutation: (state) => {
		state.giftCardPin = ''
	},
	clearCoinRedeemDataMutation: (state) => {
		state.coinRedeemValue = {}
	}
}

const actions = {
	setUserData: ({
		commit
	}, payload) => {
		commit('setUserMutation', payload)
	},
	setLoginStatus: ({
		commit
	}, payload) => {
		commit('setLoginStatusMutation', payload)
	},
	setOrderIdData: ({
		commit
	}, payload) => {
		commit('setOrderIdMutation', payload)
	},
	setUserCartData: ({
		commit
	}, payload) => {
		commit('setUserCartMutation', payload)
	},
	setPromoCodeData: ({
		commit
	}, payload) => {
		commit('setPromoCodeMutation', payload)
	},
	setProfilePictureData: ({
		commit
	}, payload) => {
		commit('setProfilePictureMutation', payload)
	},
	setOrderData: ({
		commit
	}, payload) => {
		commit('setOrderMutation', payload)
	},
	clearUserData: ({
		commit
	}, payload) => {
		commit('clearUserMutation', payload)
	},
	clearPromoCodeData: ({
		commit
	}) => {
		commit('clearPromoCodeMutation')
	},
	clearProfilePictureData: ({
		commit
	}) => {
		commit('clearProfilePictureMutation')
	},
	setAddressData: ({
		commit
	}, payload) => {
		commit('setAddressMutation', payload)
	},
	setSelectedAddressData: ({
		commit
	}, payload) => {
		commit('setSelectedAddressMutation', payload)
	},
	deleteSelectedAddressData: ({
		commit
	}, payload) => {
		commit('deleteSelectedAddressMutation', payload)
	},
	setSelectedAddressIdData: ({
		commit
	}, payload) => {
		commit('setSelectedAddressIdMutation', payload)
	},
	setGiftCardData: ({
		commit
	}, payload) => {
		commit('setGiftCardDataMutation', payload)
	},
	setGiftAmountData: ({
		commit
	}, payload) => {
		commit('setGiftAmountDataMutation', payload)
	},
	setGiftCardNo: ({
		commit
	}, payload) => {
		commit('setGiftCardNoMutation', payload)
	},
	setGiftCardPin: ({
		commit
	}, payload) => {
		commit('setGiftCardPinMutation', payload)
	},
	setCoinRedeemValue: ({
		commit
	}, payload) => {
		commit('setCoinRedeemValueMutation', payload)
	},
	clearGiftCardNo: ({
		commit
	}, payload) => {
		commit('clearGiftCardNoMutation', payload)
	},
	clearGiftCardPin: ({
		commit
	}, payload) => {
		commit('clearGiftCardPinMutation', payload)
	},
	deleteAddressData: ({
		commit
	}, payload) => {
		commit('deleteAddressMutation', payload)
	},
	clearOrderData: ({
		commit
	}, payload) => {
		commit('clearOrderMutation', payload)
	},
	clearGiftData: ({
		commit
	}, payload) => {
		commit('clearGiftDataMutation', payload)
	},
	clearGiftAmountData: ({
		commit
	}, payload) => {
		commit('clearGiftAmountDataMutation', payload)
	},
	clearCoinRedeemData: ({
		commit
	}, payload) => {
		commit('clearCoinRedeemDataMutation', payload)
	},
	clearAddressData: ({
		commit
	}, payload) => {
		commit('clearAddressMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
